import GridOnIcon from '@mui/icons-material/GridOn';
import {
  CloudQueueOutlined,
  Dashboard,
  DoubleArrow,
  ExpandLess,
  ExpandMore,
  HourglassEmpty,
  LocationOn,
  Settings,
  Share,
} from '@mui/icons-material';
import {
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Collapse,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import WeatherWallList from 'features/weatherWalls/WeatherWallList';
import { useIsAdmin } from 'features/auth/hooks/useIsAdmin';
import { useSystemModules } from 'features/systemModules/api/getSystemModules';
import { StyledDrawerList } from './StyledDrawerList';

interface Props {
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const WeatherList = ({ drawerOpen, setDrawerOpen }: Props) => {
  const isAdmin = useIsAdmin();

  const [wallListOpen, setWallistOpen] = useState(false);

  const handleWallListClick = () => {
    setWallistOpen(!wallListOpen);
    setDrawerOpen(true);
  };

  useEffect(() => {
    if (!drawerOpen) setWallistOpen(false);
  }, [drawerOpen]);

  const { data: modules } = useSystemModules({});

  useEffect(() => {
    if (!drawerOpen) {
      setWallistOpen(false);
    }
  }, [drawerOpen]);

  return (
    <StyledDrawerList sx={{ padding: 0 }}>
      <ListItemButton component={Link} to='/' key={'Dashboard'}>
        <ListItemIcon>
          <Dashboard />
        </ListItemIcon>
        <ListItemText primary={'Dashboard'} />
      </ListItemButton>

      {modules?.WEATHER && (
        <>
          <ListItemButton onClick={handleWallListClick}>
            <ListItemIcon>
              <GridOnIcon />
            </ListItemIcon>
            <ListItemText primary='Walls' />
            {wallListOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse in={wallListOpen} timeout='auto' unmountOnExit>
            <WeatherWallList />
          </Collapse>
          {isAdmin && (
            <ListItemButton component={Link} to='/weathershare'>
              <ListItemIcon>
                <Share />
              </ListItemIcon>
              <ListItemText primary='Share' />
            </ListItemButton>
          )}
          <ListItemButton component={Link} to='/weatherwalls'>
            <ListItemIcon>
              <Settings />
            </ListItemIcon>
            {drawerOpen ? (
              <ListItemText primary='Wall Configuration' />
            ) : (
              <ListItemText primary='Link' />
            )}
          </ListItemButton>
          {isAdmin && (
            <ListItemButton component={Link} to='/weatheralerts'>
              <ListItemIcon>
                <CloudQueueOutlined />
              </ListItemIcon>
              {drawerOpen ? (
                <ListItemText primary='Weather Alerts' />
              ) : (
                <ListItemText primary='Link' />
              )}
            </ListItemButton>
          )}
        </>
      )}
      <ListItemButton
        component={Link}
        to='/reflection'
        key={'History Reflection'}
      >
        <ListItemIcon>
          <HourglassEmpty />
        </ListItemIcon>
        {drawerOpen ? (
          <ListItemText primary={'History Reflection'} />
        ) : (
          <ListItemText primary={'Link'} />
        )}
      </ListItemButton>
      <ListItemButton
        component={Link}
        to='/forecast-reflection'
        key={'Forecast Reflection'}
      >
        <ListItemIcon>
          <DoubleArrow />
        </ListItemIcon>
        {drawerOpen ? (
          <ListItemText primary={'Forecast Reflection'} />
        ) : (
          <ListItemText primary={'Link'} />
        )}
      </ListItemButton>
      {isAdmin && (
        <ListItemButton component={Link} to='/locations'>
          <ListItemIcon>
            <LocationOn />
          </ListItemIcon>
          <ListItemText primary='Locations' />
        </ListItemButton>
      )}
    </StyledDrawerList>
  );
};

export default WeatherList;
